import { mergeLocales, type Language } from 'common/i18n';
import { get } from 'pc-sales/utils/http';
import enUs from './en-US/index';
import zhCn from './zh-CN/index';
import zhTw from './zh-TW/index';

export default async (language: Language, mtsLang: Record<string, string>): Promise<any> => {
    let commonCdn = window.common_translation_address;
    let salesCdn = window.translation_address;
    let salesDefaultLocale: Record<string, any>;
    let commonDefaultLocale: Record<string, any>;
    const defaultLocal: Record<string, any> = enUs;
    const langLocalMap: Record<string, any> = {
        'zh-CN': zhCn,
        'zh-TW': zhTw,
    };
    try {
        const [sales, common] = await Promise.all([get(`${salesCdn}en_us.json`), get(`${commonCdn}en_us.json`)]);
        salesDefaultLocale = sales;
        commonDefaultLocale = common;
    } catch (error) {
        console.error('The translation language CDN is invalid.');
        // 若线上翻译CDN失效，使用本地语言文件
        commonCdn = '/json/lang/common/';
        salesCdn = '/json/lang/sales/';
        const [sales, common] = await Promise.all([get(`${salesCdn}en_us.json`), get(`${commonCdn}en_us.json`)]);
        salesDefaultLocale = sales;
        commonDefaultLocale = common;
    }
    // 默认使用英文语言文件
    const defaultLocale = mergeLocales(salesDefaultLocale, commonDefaultLocale, defaultLocal);
    let locale = {};
    if (mtsLang[language] && language !== 'en-US') {
        try {
            const [salesCns, commonCns] = await Promise.all([
                get(`${salesCdn}${mtsLang[language]}.json`),
                get(`${commonCdn}${mtsLang[language]}.json`),
            ]);
            locale = mergeLocales(salesCns, commonCns, langLocalMap[language] || {});
        } catch (err) {
            // 忽略
        }
    }
    return { [language]: mergeLocales(locale, defaultLocale) };
};
